/**
 * UnipileConnectBannerPure
 *
 * Pure presentational component for LinkedIn connection prompt.
 * No server dependencies - all data and callbacks passed via props.
 */
import { Button } from '../Input2';
import { General } from '../StrokeIcons';

// ============================================================================
// Types
// ============================================================================

export type UnipileConnectBannerPureProps = {
  onConnect: () => void;
  isConnecting?: boolean;
};

// ============================================================================
// Component
// ============================================================================

export function UnipileConnectBannerPure({ onConnect, isConnecting }: UnipileConnectBannerPureProps) {
  return (
    <div className="mb-2 rounded-lg border border-blue-200 bg-blue-50 p-3 dark:border-blue-800 dark:bg-blue-950/30">
      <div className="mb-2 flex items-center gap-2">
        <div className="flex size-8 items-center justify-center rounded-md bg-blue-500">
          <General.Link01 className="size-4 text-white" />
        </div>
        <div>
          <p className="text-sm font-medium text-blue-900 dark:text-blue-100">Connect LinkedIn</p>
          <p className="text-xs text-blue-700 dark:text-blue-300">Required to send messages directly</p>
        </div>
      </div>
      <Button
        color="blue"
        size="sm"
        className="w-full"
        onClick={onConnect}
        disabled={isConnecting}
        icon={<General.Link01 />}>
        Connect LinkedIn Account
      </Button>
    </div>
  );
}
